const { Flex } = require('antd');
const { default: Image } = require('next/image');
import styles from '@/components/app/upgrade/upgrade-view.module.css';
import crown from 'public/images/app/crown-upgrade.svg';

export default function UpgradeBanner({ children }) {
   return (
      <Flex vertical gap={16} style={{ width: '100%', position: 'relative', overflow: 'hidden',padding: '16px' }}>
         {children}
         <Flex className={styles.banner} align="center">
            <Image
               src={crown}
               alt={'crown'}
               width={150}
               height={150}
               style={{ position: 'absolute', top: '15%', left: '2%', transform: 'scaleX(-1)' }}
            />
            <p className={styles.bannerHeading}>
               Join many worldwide people and companies who trust us with their presentations.{' '}
            </p>
            <Image
               src={crown}
               alt={'crown'}
               width={150}
               height={150}
               style={{ position: 'absolute', bottom: '5%', right: '5%' }}
            />
         </Flex>
      </Flex>
   );
}
